export interface IconProps {
  class?: string;
  size?: number;
}

export type IconName =
  | "cpu" | "stack" | "clouds" | "shield" | "folder" | "tune"
  | "lock" | "chip" | "play" | "arrow" | "arrowUp" | "arrowDown"
  | "bolt" | "github" | "discord" | "book" | "chat" | "status"
  | "ucloud" | "check" | "plus" | "chevron" | "terminal"
  | "globe" | "sparkle" | "code" | "video" | "bookmark" | "history";

function svg(size: number, content: string, cls?: string): string {
  const c = cls ? ` class="${cls}"` : "";
  return `<svg${c} width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${content}</svg>`;
}

export const icon: Record<IconName, (props: IconProps) => string> = {
  cpu: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<rect x="6" y="6" width="12" height="12" rx="1"/><path d="M9 1v3M15 1v3M9 20v3M15 20v3M1 9h3M1 15h3M20 9h3M20 15h3"/><rect x="10" y="10" width="4" height="4"/>`, props.class),
  stack: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M12 3 3 7.5 12 12 21 7.5 12 3zM3 12l9 4.5L21 12M3 16.5 12 21l9-4.5"/>`, props.class),
  clouds: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M17.5 19a4.5 4.5 0 1 0-1.3-8.8 6 6 0 0 0-11.6 1.8A4 4 0 0 0 5 19h12.5z"/>`, props.class),
  shield: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M12 2 4 6v6c0 5 3.4 8.7 8 10 4.6-1.3 8-5 8-10V6l-8-4z"/><path d="m9 12 2 2 4-4"/>`, props.class),
  folder: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z"/>`, props.class),
  tune: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M4 6h10M18 6h2M4 12h2M10 12h10M4 18h12M18 18h2"/><circle cx="16" cy="6" r="2"/><circle cx="8" cy="12" r="2"/><circle cx="14" cy="18" r="2"/>`, props.class),
  lock: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>`, props.class),
  chip: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<rect x="4" y="4" width="16" height="16" rx="2"/><path d="M9 9h6v6H9z"/>`, props.class),
  play: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M7 5l12 7-12 7V5z"/>`, props.class),
  arrow: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M5 12h14M13 6l6 6-6 6"/>`, props.class),
  arrowUp: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M12 19V5M6 11l6-6 6 6"/>`, props.class),
  arrowDown: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M12 5v14M6 13l6 6 6-6"/>`, props.class),
  bolt: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M13 2 4 14h8l-1 8 9-12h-8z"/>`, props.class),
  github: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M12 2a10 10 0 0 0-3.16 19.49c.5.09.68-.22.68-.49v-1.7c-2.78.6-3.37-1.34-3.37-1.34-.45-1.16-1.1-1.47-1.1-1.47-.9-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.9 1.53 2.34 1.09 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.94 0-1.09.39-1.98 1.03-2.68-.1-.25-.45-1.27.1-2.65 0 0 .84-.27 2.75 1.02a9.6 9.6 0 0 1 5 0c1.91-1.29 2.75-1.02 2.75-1.02.55 1.38.2 2.4.1 2.65.64.7 1.03 1.59 1.03 2.68 0 3.84-2.34 4.69-4.57 4.94.36.31.68.92.68 1.85v2.74c0 .27.18.59.69.49A10 10 0 0 0 12 2z"/>`, props.class),
  discord: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M19 5a17 17 0 0 0-4-1l-.3.5a13 13 0 0 1 3.6 1.2c-3-1.4-6.6-1.4-9.6 0A13 13 0 0 1 12.6 4.5L12.4 4c-1.4.2-2.7.6-4 1A17 17 0 0 0 4 17c1.5 1.6 3.4 2.5 5.5 3l.6-1c-1-.3-1.9-.7-2.7-1.3l.4-.3a12 12 0 0 0 10.4 0l.4.3c-.8.6-1.7 1-2.7 1.3l.6 1c2.1-.5 4-1.4 5.5-3l.4-.4zM9 15a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8zm6 0a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8z"/>`, props.class),
  book: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M4 4a2 2 0 0 1 2-2h12v18H6a2 2 0 0 0-2 2V4zM6 18h12"/>`, props.class),
  chat: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M21 11.5a8.4 8.4 0 0 1-9.5 8.4L4 21l1.1-7.5A8.4 8.4 0 1 1 21 11.5z"/>`, props.class),
  status: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3" fill="currentColor" stroke="none"/>`, props.class),
  ucloud: (props: IconProps = {}) =>
    svg(props.size ?? 28, `<path d="M14 3 5 8 5 17 14 22 23 17 23 8z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M14 7 9 11 14 15 19 11z" fill="currentColor" stroke="none"/>`, props.class),
  check: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M5 13l4 4L19 7"/>`, props.class),
  plus: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M12 5v14M5 12h14"/>`, props.class),
  chevron: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M6 9l6 6 6-6"/>`, props.class),
  terminal: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M7 9l3 3-3 3M13 15h4"/>`, props.class),
  globe: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/>`, props.class),
  sparkle: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M12 3l1.8 4.7L18.5 9.5 13.8 11.3 12 16l-1.8-4.7L5.5 9.5l4.7-1.8zM18 14l.8 2.2L21 17l-2.2.8L18 20l-.8-2.2L15 17l2.2-.8z"/>`, props.class),
  code: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M9 9 4 14l5 5M15 9l5 5-5 5"/>`, props.class),
  video: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<rect x="3" y="6" width="13" height="12" rx="2"/><path d="M16 10l5-3v10l-5-3"/>`, props.class),
  bookmark: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M6 3h12v18l-6-4-6 4z"/>`, props.class),
  history: (props: IconProps = {}) =>
    svg(props.size ?? 24, `<path d="M3 12a9 9 0 1 0 3-6.7M3 4v5h5"/><path d="M12 8v4l3 2"/>`, props.class),
};
